// Valores por defecto de categories.
export const defaultCategoriesSga = () => {
    return [];
};

// Valor por defecto de action.
export const defaultAction = () => {
    return "";
};

// Valor por defecto de category.
export const defaultCategory = () => {
    return {
        id: null,
        name: null,
        sga_type_of_danger_id: null,
        sga_category_languages: [],
    };
};

// Valores por defecto de filterCategoriesSga.
export const defaultFilterSgaCategories = () => {
    return {
        name: null,
        is_active: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

// Valores por defecto de activeCategories.
export const defaultActiveCategories = () => {
    return [];
};

export default {
    categories: defaultCategoriesSga(),
    action: defaultAction(),
    category: defaultCategory(),
    filterCategoriesSga: defaultFilterSgaCategories(),
    activeCategories: defaultActiveCategories(),
};
